"use client"

import axios from "axios"
import { useEffect, useState } from "react"
import { NotificationManager } from "react-notifications"
import Modal from "../../../components/Modal/Modal"
import useAuth from "../../../hooks/useAuth"
import { BASE_URL } from "../../../utils/Element"
import AddCommissionData from "./AddCommissionData"

const initialData = {
  total_commission: 0,
  broker_record_fee: 0,
  referal_fee: 0,
  misc_fee: 0,
  gross_commission_income: 0,
  brokers: [{ commission_amount_broker: 0, amount_broker: 0 }],
  bds: [{ commission_amount_bds: 0, amount: 0 }],
  company_gross_commission: 0,
}

const AddCommission = ({ showModal, onClose, onCallApi, id }) => {
  const [config] = useAuth()
  const [error, setError] = useState(null)
  const [disable, setDisable] = useState(false)
  const [formData, setFormData] = useState(initialData)
  const [search, setSearch] = useState("")
  const [isBuyerBDSDollar, setIsBuyerBDSDollar] = useState(true)
  const [isDollar, setIsDollar] = useState(true)

  /* -----------------------------------------------
     CLOSE HANDLER
  -------------------------------------------------- */
  const handleClose = () => {
    setFormData(initialData)
    setError(null)
    setDisable(false)
    setSearch("")
    onClose()
  }

  /* -----------------------------------------------
     LOAD DATA ON OPEN
  -------------------------------------------------- */
  useEffect(() => {
    if (!showModal) return

    axios
      .get(`${BASE_URL}/contract-to-close/${id}`, config)
      .then((res) => {
        const api = res?.data?.data

        const mappedData = {
          broker_record_fee: api?.broker_record_fee ?? "",
          misc_fee: api?.misc_fee ?? "",
          referal_fee: api?.referal_fee ?? "",
          total_commission: api?.total_commission_price
            ? api.total_commission_price
            : "",

          brokers: api?.broker_breakdowns?.length
            ? api.broker_breakdowns.map((item) => ({
              contact: { id: item.broker_id, name: item.broker_name },
              commission_amount_broker: item.percentage,
              amount_broker: item.total_value,
              type: item.type,
            }))
            : [{
              contact: { id: "", name: "" },
              commission_amount_broker: "",
              amount_broker: "",
              type: "",
            }],

          bds: api?.bds_breakdowns?.length
            ? api.bds_breakdowns.map((item) => ({
              contact: { id: item.bds_id, name: item.bds_name },
              commission_amount_bds: item.percentage,
              amount: item.total_value,
              type: item.type,
            }))
            : [{
              contact: { id: "", name: "" },
              commission_amount_bds: "",
              amount: "",
              type: "",
            }],
        }

        setFormData(mappedData)
      })
      .catch((err) => {
        if (err.response?.data?.message) {
          NotificationManager.error(err.response.data.message)
        }
      })
  }, [showModal, id])


  const submitCommission = async (save = false) => {
    setDisable(true)

    const dataToSend = {
      total_commission: formData?.total_commission,
      broker_record_fee: formData?.broker_record_fee,
      referal_fee: formData?.referal_fee,
      misc_fee: formData?.misc_fee,
      gross_commission_income: formData?.gross_commission_income,
      brokers: formData?.brokers,
      bds: formData?.bds,
      company_gross_commission: formData?.company_gross_commission,
      brokers_type: isBuyerBDSDollar ? "dollar" : "percent",
      bds_type: isDollar ? "dollar" : "percent",
      save: save,
    }

    try {
      await axios.post(
        `${BASE_URL}/contract-to-close-commissionfee/${id}`,
        dataToSend,
        config
      )

      onCallApi()
      NotificationManager.success("Commission added successfully")
      return null
    } catch (err) {
      const message = err.response?.data?.message
      setError(message)
      return message
    } finally {
      setDisable(false)
    }
  }

  return (
    <Modal
      title="Add Commission Breakdown"
      desc="Add the Commission Breakdown information."
      show={showModal}
      onClose={handleClose}
    >
      <AddCommissionData
        formData={formData}
        error={error}
        onSetFormData={setFormData}
        onSetError={setError}
        handleSubmit={submitCommission}
        isBuyerBDSDollar={isBuyerBDSDollar}
        setIsBuyerBDSDollar={setIsBuyerBDSDollar}
        isDollar={isDollar}
        setIsDollar={setIsDollar}
        handleClose={handleClose}
        search={search}
        showModal={showModal}
        disable={disable}
      />
    </Modal>
  )
}

export default AddCommission
